var map = {
	"./Ubisoft-plus-cloud-gaming-devices_desktop.png": 240,
	"./Ubisoft-plus-cloud-gaming-devices_desktop.webp": 59,
	"./Ubisoft-plus-cloud-gaming-devices_mobile.png": 241,
	"./Ubisoft-plus-cloud-gaming-devices_mobile.webp": 60,
	"./Ubisoft-plus-cloud-gaming-devices_tablet.png": 242,
	"./Ubisoft-plus-cloud-gaming-devices_tablet.webp": 61,
	"./Ubisoft-plus-crew-2-gold-edition_desktop.png": 243,
	"./Ubisoft-plus-crew-2-gold-edition_desktop.webp": 62,
	"./Ubisoft-plus-crew-2-gold-edition_mobile.png": 244,
	"./Ubisoft-plus-crew-2-gold-edition_mobile.webp": 63,
	"./Ubisoft-plus-crew-2-gold-edition_tablet.png": 245,
	"./Ubisoft-plus-crew-2-gold-edition_tablet.webp": 64,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_desktop.png": 246,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_desktop.webp": 65,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_mobile.png": 247,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_mobile.webp": 66,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_tablet.png": 248,
	"./Ubisoft-plus-game-library-Ubisoft-Connect_tablet.webp": 67,
	"./Ubisoft-plus-mouse-icon.svg": 41,
	"./Ubisoft-plus-mouse-icon_emea.svg": 42,
	"./Ubisoft-plus-open-lock-icon.svg": 43,
	"./Ubisoft-plus-quality-badge-icon.svg": 44,
	"./Ubisoft-plus-star-icon.svg": 45,
	"./Ubisoft-plus-wings-icon.svg": 46,
	"./Ubisoft-plus-wings-icon_emea.svg": 47,
	"./Uplay+_colours.pdf": 249,
	"./Uplayplus_LP_carousel_ACOD.jpg": 250,
	"./Uplayplus_LP_carousel_ACOD.webp": 68,
	"./Uplayplus_LP_carousel_ACOD_desktop.png": 251,
	"./Uplayplus_LP_carousel_ACOD_desktop.webp": 69,
	"./Uplayplus_LP_carousel_ACOD_mobile.png": 252,
	"./Uplayplus_LP_carousel_ACOD_mobile.webp": 70,
	"./Uplayplus_LP_carousel_ACOD_tablet.png": 253,
	"./Uplayplus_LP_carousel_ACOD_tablet.webp": 71,
	"./Uplayplus_LP_carousel_ACV_desktop.png": 254,
	"./Uplayplus_LP_carousel_ACV_desktop.webp": 72,
	"./Uplayplus_LP_carousel_ACV_mobile.png": 255,
	"./Uplayplus_LP_carousel_ACV_mobile.webp": 73,
	"./Uplayplus_LP_carousel_ACV_tablet.png": 256,
	"./Uplayplus_LP_carousel_ACV_tablet.webp": 74,
	"./Uplayplus_LP_carousel_Anno1800_desktop.png": 257,
	"./Uplayplus_LP_carousel_Anno1800_desktop.webp": 75,
	"./Uplayplus_LP_carousel_Anno1800_mobile.png": 258,
	"./Uplayplus_LP_carousel_Anno1800_mobile.webp": 76,
	"./Uplayplus_LP_carousel_Anno1800_tablet.png": 259,
	"./Uplayplus_LP_carousel_Anno1800_tablet.webp": 77,
	"./Uplayplus_LP_carousel_FC5_desktop.png": 260,
	"./Uplayplus_LP_carousel_FC5_desktop.webp": 78,
	"./Uplayplus_LP_carousel_FC5_mobile.png": 261,
	"./Uplayplus_LP_carousel_FC5_mobile.webp": 79,
	"./Uplayplus_LP_carousel_FC5_tablet.png": 262,
	"./Uplayplus_LP_carousel_FC5_tablet.webp": 80,
	"./Uplayplus_LP_carousel_FCND_desktop.png": 263,
	"./Uplayplus_LP_carousel_FCND_desktop.webp": 81,
	"./Uplayplus_LP_carousel_FCND_mobile.png": 264,
	"./Uplayplus_LP_carousel_FCND_mobile.webp": 82,
	"./Uplayplus_LP_carousel_FCND_tablet.png": 265,
	"./Uplayplus_LP_carousel_FCND_tablet.webp": 83,
	"./Uplayplus_LP_carousel_FH_desktop.png": 266,
	"./Uplayplus_LP_carousel_FH_desktop.webp": 84,
	"./Uplayplus_LP_carousel_FH_mobile.png": 267,
	"./Uplayplus_LP_carousel_FH_mobile.webp": 85,
	"./Uplayplus_LP_carousel_FH_tablet.png": 268,
	"./Uplayplus_LP_carousel_FH_tablet.webp": 86,
	"./Uplayplus_LP_carousel_GRBP_desktop.png": 269,
	"./Uplayplus_LP_carousel_GRBP_desktop.webp": 87,
	"./Uplayplus_LP_carousel_GRBP_mobile.png": 270,
	"./Uplayplus_LP_carousel_GRBP_mobile.webp": 88,
	"./Uplayplus_LP_carousel_GRBP_tablet.png": 271,
	"./Uplayplus_LP_carousel_GRBP_tablet.webp": 89,
	"./Uplayplus_LP_carousel_IFR_desktop.png": 272,
	"./Uplayplus_LP_carousel_IFR_desktop.webp": 90,
	"./Uplayplus_LP_carousel_IFR_mobile.png": 273,
	"./Uplayplus_LP_carousel_IFR_mobile.webp": 91,
	"./Uplayplus_LP_carousel_IFR_tablet.png": 274,
	"./Uplayplus_LP_carousel_IFR_tablet.webp": 92,
	"./Uplayplus_LP_carousel_PoPFS_desktop.png": 275,
	"./Uplayplus_LP_carousel_PoPFS_desktop.webp": 93,
	"./Uplayplus_LP_carousel_PoPFS_mobile.png": 276,
	"./Uplayplus_LP_carousel_PoPFS_mobile.webp": 94,
	"./Uplayplus_LP_carousel_PoPFS_tablet.png": 277,
	"./Uplayplus_LP_carousel_PoPFS_tablet.webp": 95,
	"./Uplayplus_LP_carousel_R6S_desktop.png": 278,
	"./Uplayplus_LP_carousel_R6S_desktop.webp": 96,
	"./Uplayplus_LP_carousel_R6S_mobile.png": 279,
	"./Uplayplus_LP_carousel_R6S_mobile.webp": 97,
	"./Uplayplus_LP_carousel_R6S_tablet.png": 280,
	"./Uplayplus_LP_carousel_R6S_tablet.webp": 98,
	"./Uplayplus_LP_carousel_SCblacklist_desktop.png": 281,
	"./Uplayplus_LP_carousel_SCblacklist_desktop.webp": 99,
	"./Uplayplus_LP_carousel_SCblacklist_mobile.png": 282,
	"./Uplayplus_LP_carousel_SCblacklist_mobile.webp": 100,
	"./Uplayplus_LP_carousel_SCblacklist_tablet.png": 283,
	"./Uplayplus_LP_carousel_SCblacklist_tablet.webp": 101,
	"./Uplayplus_LP_carousel_TC2_desktop.png": 284,
	"./Uplayplus_LP_carousel_TC2_desktop.webp": 102,
	"./Uplayplus_LP_carousel_TC2_mobile.png": 285,
	"./Uplayplus_LP_carousel_TC2_mobile.webp": 103,
	"./Uplayplus_LP_carousel_TC2_tablet.png": 286,
	"./Uplayplus_LP_carousel_TC2_tablet.webp": 104,
	"./Uplayplus_LP_carousel_TCTD2_desktop.png": 287,
	"./Uplayplus_LP_carousel_TCTD2_desktop.webp": 105,
	"./Uplayplus_LP_carousel_TCTD2_mobile.png": 288,
	"./Uplayplus_LP_carousel_TCTD2_mobile.webp": 106,
	"./Uplayplus_LP_carousel_TCTD2_tablet.png": 289,
	"./Uplayplus_LP_carousel_TCTD2_tablet.webp": 107,
	"./Uplayplus_LP_carousel_TrialsRising_desktop.png": 290,
	"./Uplayplus_LP_carousel_TrialsRising_desktop.webp": 108,
	"./Uplayplus_LP_carousel_TrialsRising_mobile.png": 291,
	"./Uplayplus_LP_carousel_TrialsRising_mobile.webp": 109,
	"./Uplayplus_LP_carousel_TrialsRising_tablet.png": 292,
	"./Uplayplus_LP_carousel_TrialsRising_tablet.webp": 110,
	"./Uplayplus_LP_carousel_WDL.jpg": 293,
	"./Uplayplus_LP_carousel_WDL_desktop.png": 294,
	"./Uplayplus_LP_carousel_WDL_desktop.webp": 111,
	"./Uplayplus_LP_carousel_WDL_mobile.png": 295,
	"./Uplayplus_LP_carousel_WDL_mobile.webp": 112,
	"./Uplayplus_LP_carousel_WDL_tablet.png": 296,
	"./Uplayplus_LP_carousel_WDL_tablet.webp": 113,
	"./acv_slide_desktop.jpg": 297,
	"./acv_slide_desktop.webp": 114,
	"./acv_slide_mobile.jpg": 298,
	"./acv_slide_mobile.webp": 115,
	"./acv_slide_tablet.jpg": 299,
	"./acv_slide_tablet.webp": 116,
	"./banners_logo_luna.png": 300,
	"./banners_logo_luna.webp": 117,
	"./banners_logo_stadia.png": 301,
	"./banners_logo_stadia.webp": 118,
	"./fc6_slide_desktop.webp": 119,
	"./fc6_slide_logo.png": 302,
	"./fc6_slide_logo.webp": 120,
	"./fc6_slide_mobile.webp": 121,
	"./fc6_slide_tablet.webp": 122,
	"./gm_slide_desktop.jpg": 303,
	"./gm_slide_desktop.webp": 123,
	"./gm_slide_mobile.jpg": 304,
	"./gm_slide_mobile.webp": 124,
	"./gm_slide_tablet.jpg": 305,
	"./gm_slide_tablet.webp": 125,
	"./mad_slide_desktop.webp": 126,
	"./mad_slide_mobile.webp": 127,
	"./mad_slide_tablet.webp": 128,
	"./old_banners_assets/Ubisoft-plus-cloud-gaming-devices.png": 306,
	"./old_banners_assets/Ubisoft-plus-cloud-gaming-devices.webp": 129,
	"./old_banners_assets/Ubisoft-plus-crew-2-gold-edition.png": 307,
	"./old_banners_assets/Ubisoft-plus-crew-2-gold-edition.webp": 130,
	"./old_banners_assets/Ubisoft-plus-game-library-Ubisoft-Connect.png": 308,
	"./old_banners_assets/Ubisoft-plus-game-library-Ubisoft-Connect.webp": 131,
	"./old_banners_assets/fc6_slide_desktop.jpg": 309,
	"./old_banners_assets/fc6_slide_mobile.jpg": 310,
	"./old_banners_assets/fc6_slide_tablet.jpg": 311,
	"./old_banners_assets/mad_slide_desktop.jpg": 312,
	"./old_banners_assets/mad_slide_mobile.jpg": 313,
	"./old_banners_assets/mad_slide_tablet.jpg": 314,
	"./play-button.svg": 48,
	"./pps_slide_desktop.jpg": 315,
	"./pps_slide_desktop.webp": 132,
	"./pps_slide_mobile.jpg": 316,
	"./pps_slide_mobile.webp": 133,
	"./pps_slide_tablet.jpg": 317,
	"./pps_slide_tablet.webp": 134,
	"./slidernav_left.svg": 49,
	"./slidernav_right.svg": 50,
	"./sp_slide_desktop.jpg": 318,
	"./sp_slide_desktop.webp": 135,
	"./sp_slide_mobile.jpg": 319,
	"./sp_slide_mobile.webp": 136,
	"./sp_slide_tablet.jpg": 320,
	"./sp_slide_tablet.webp": 137,
	"./ubisoft-plus_hero_desktop.jpg": 20,
	"./ubisoft-plus_hero_mobile.jpg": 21,
	"./ubisoft-plus_rewards_program_desktop.png": 321,
	"./ubisoft-plus_rewards_program_desktop.webp": 138,
	"./ubisoft-plus_rewards_program_mobile.png": 322,
	"./ubisoft-plus_rewards_program_mobile.webp": 139,
	"./ubisoft-plus_rewards_program_tablet.png": 323,
	"./ubisoft-plus_rewards_program_tablet.webp": 140,
	"./ubisoft_plus_logo.svg": 17,
	"./uplayplus-ico-download.svg": 51,
	"./uplayplus-ico-earlyaccess.svg": 52,
	"./uplayplus-ico-newreleases.svg": 53,
	"./uplayplus-ico-playtrailer.svg": 54,
	"./uplayplus-ico-plus.svg": 55,
	"./uplayplus-ico-premium.svg": 56,
	"./uplayplus-logo-whtblue.svg": 57,
	"./valhala_fenyx_rysing_background_desktop.jpg": 324,
	"./valhala_fenyx_rysing_background_desktop.webp": 141,
	"./valhala_fenyx_rysing_background_mobile.jpg": 325,
	"./valhala_fenyx_rysing_background_mobile.webp": 142,
	"./wdl_logo.png": 326,
	"./wdl_logo.webp": 143,
	"./wdl_slide_desktop.jpg": 327,
	"./wdl_slide_desktop.webp": 144,
	"./wdl_slide_mobile.jpg": 328,
	"./wdl_slide_mobile.webp": 145,
	"./wdl_slide_tablet.jpg": 329,
	"./wdl_slide_tablet.webp": 146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;